<dw-ui-dialog-box [title]="'Doc::ReturnNote:ToCreditNote'" (saveFn)="save()">
  <div>
    <document-return-note-to-credit-note-grid
      [currentReturnNoteId]="returnNoteId"
      [lines]="returnNotes$ | async"
      (selectionChange)="returnNoteSelectionChange($event)"
    >
    </document-return-note-to-credit-note-grid>
  </div>

  <div class="mt-5">
    <document-customer-credit-note-preview-grid
      [lines]="previewCreditNoteLines$ | async"
      [returnNotes]="selectedReturnNotes$ | async"
    ></document-customer-credit-note-preview-grid>
  </div>
</dw-ui-dialog-box>
